export default class Uri {
	baseURL: string = (process.env.VUE_APP_HOST ? process.env.VUE_APP_HOST : '') + process.env.VUE_APP_API;
	/*Common*/
	designConfig = 'system/color';
	userInfo = 'current-user/detail-info';
	changePassword = 'current-user/update-password';
	changeRole = 'users/update-active-role';
	infoSystemInfo = 'info/systeminfo/';
	infoSystemInfoLogin = 'info/systeminfologin';
	i18nLkk = 'i18n';
	about = 'info/version/all';
	modulesAbout = 'info/version/all-modules';
	logout = 'logout';
	env = 'env';

	/*Login*/
	login = 'login';

	/*LKB*/
	application = 'application/';

	appId(id: string): string { return `${this.application}${id}/`; }
	downloadStorageZipped: string = `/application/zipped`;
	downloadStorageRequestList = '/storage-request/download';
	downloadDocument(fileId: string): string { return `file-download/${fileId}`; }
  	individualStorageRequestCreateForm(fileId: string): string { return `individual/storage-request/create-form/${fileId}`; }
	downloadFile(docId: string): string { return this.binary + '/' + docId; }
	searchAddr = 'suggest/address';
	searchOrg = 'suggest/org';
	searchCountry = 'suggest/country';

  	metaClient(id: string): string { return `s3/clients/${id}/download`; }
	/*Applications*/

	metadataResultstorageRequest(objectId:string): string { return `s3/storage-request/${objectId}/metadata`; }
	metadataResultstorageRequestUl(objectId:string): string { return `storage-request/${objectId}/metadata`; }
	metadataResultclients(objectId:string, executetime:string): string { return `s3/clients/${objectId}/${executetime}/metadata`; }
	metadataResultclient(objectId:string): string { return `client/${objectId}/metadata`; }
	metadataResultByTemplateId(requestId:string, templateId: string): string { return `electronic-document/${requestId}/${templateId}/metadata`; }

	metadataResult(objectId:string, executetime:string): string { return `s3/clients/${objectId}/${executetime}/metadata`; }

	refDocumentLink(fileId: string): string { return `refdocument/${fileId}/link`; }
	applications = 'application/all';
	saveFilter(type: string): string { return 'filter/' + type; }
	blocks = 'application/all-block';

	/*ClientList*/
	clientReport = 'client/report/';
	reportCount = 'client/report/count';
	deleteClient(id: string): string { return `client/${id}`; }
	editLegalClient(id: string): string { return `client/${id}`; }
	clientApplications(id: string): string { return `client/application?clientId=${id}`; }
	deleteClientApp(id: string): string { return `client/application?appId=${id}`; }

	/*bank questionnairies*/
	bankForm = 'bankform';
	typeDocsLkbFormBank = 'documenttypes/subtype/LKB_FORM_BANK';
	recognitionPassport = 'scanning/passport';
	valuesForm = 'valuesform';
	testbankform = 'testbankform';
	form = 'form';
	migration = 'form/migration';
	form2 = 'bankform';
	downloadForm(id: string): string { return `${this.form}/${id}`; }
	downloadForm2(id: string): string { return `${this.form2}/${id}`; }
	formLkr = 'form?system=LKR';
	formLkk = 'form?system=LKK';
	/*StatusModel*/
	statusIndividual = 'status-individual';
	initiatorsRequestFl = 'storage-request/individual/initiator';
	initiatorsRequestlegal = 'storage-request/legal-entity/initiator';
	storageRequestStatus = 'storage-request/status';

	/*DocumentsTypes*/
	documenttype = 'documenttype';
	documenttypeId(id: string, type: string): string { return `${this.documenttype}/${id}/${type}`; }
	documenttypeClientType(id: string): string { return `${this.documenttype}/${id}`; }
	order = 'documenttype/order';
	documenttypeInfo = 'documenttype/info';
  	documentstorageRequestTemporary = 'application/temporary-document';
	blockedDocs = 'documenttype/all-delete';
	unBlockedDocs(id: string, type: string): string { return `${this.documenttype}/${id}/${type}/extract-archive`; }
	storageRequestTemporaryDocumenun(id: string): string { return '/application/' + id + '/temporary-document'; }
	storageRequestFileNames(id: string, legalEntityType: string): string { return `${this.documenttype}/${id}/${legalEntityType}`; }
	storageRequestFileRename(fileId: string): string {return `storage-request/${fileId}/rename`;}

	storageContractNumberList(requestId: string): string {return `individual/storage-request/contract-number/${requestId}`;}
	storageContractNumberLegalList(requestId: string): string {return `legal-entity/storage-request/contract-number/${requestId}`;}

	/*Internationalization*/
	binary = 'binary';
	binaryLegEntity: string = this.binary + '/legal-entity';
	binaryIndividual: string = this.binary + '/individual';
	binaryManager: string = this.binary + '/employee';
	localeList = 'i18n/language';
	/*get - получить список, post - изменить*/
	localeSelect(id: string): string { return `i18n/${id}`; }

	/*Users/users*/
	users = 'users/all';
	roles = 'role/all';
	client = 'client';
	rolesSigners = 'role/signers'; // Роли которые Подписанты
	addUser = 'users/add';
	validUserDomain(domainName: string): string { return `users/validate/${domainName}`; }
	updateUser = 'users/update';
	blockedUsers = 'users/all/archive';
	blockedUser(id: string): string { return `users/to-archive/${id}`; }
	unBlockedUser(id: string): string { return `users/extract-archive/${id}`; }

	/*Users/roles*/
	menu = 'client-menu/all';
	menuTree = 'client-menu/all-tree';
	privileges = 'privilege/all';
	addRole = 'role/add';
	updateRole = 'role/update';
	sortRole = 'role/update/order';
	blockedRoles = 'role/all/archive';
	blockedRole(id: string): string { return `role/to-archive/${id}`; }
	unBlockedRole(id: string): string { return `role/extract-archive/${id}`; }

	/*Administration*/
	mainsysset = 'admin/sysflag';
	sysParameters = 'admin/sysparameter';
	dropBD = 'admin/truncatedb';
	filesHash = 'admin/individual/files-hash';
	resetContractNumberCash = 'admin/reset-contract-number';
	exportInfo = 'database/info';
	downloadFileExportInfo = 'database/export';
	uploadSetting = 'database/import';
	desingEnvByScope(scope: string): string {return `design/env/${scope}`};
	desingEnv = 'design/env/';
	uploadEnvImage = 'design/env/image';
	fileDownload(srcImg: string): string { return `file-download/${srcImg}`; }
	binaryLoadImg(srcImg: string): string { return `${this.binary}/${srcImg}`; }
	binaryLoadImgDesing(srcImg: string): string { return `${this.baseURL}${this.binary}/${srcImg}`; }

	/*ApplicationStatuses*/
  	statusIndividualId(id: string): string { return `${this.statusIndividual}/${id}`; }

	/*Setting: BanksAndOffices*/
	office = 'office';
	bankOffices = 'bankoffices';
	bankOfficesOrder = 'office/update/order';
	regionOfficesOrder = 'region/update/order';
	region = 'region';
	regionId(id: string): string { return `${this.region}/${id}`; }
	showRegionId(id: string): string { return `${this.region}/extract-archive/${id}`; }
	bank = 'bank';
	bankId(id: string): string { return `${this.bank}/${id}`; }
	saveOffice(bankid: string, regionid: string): string { return `${this.office}/${bankid}/${regionid}`; }
	officeId(id: string): string { return `${this.office}/${id}`; }
	showOfficeId(id: string): string { return `${this.office}/extract-archive/${id}`; }

	/*Notification*/
	mailTemplate = 'mailtemplate';
	mailTemplateId(id: string): string { return `${this.mailTemplate}/${id}`; }
  	mailTemplateIndividual = 'mailtemplate-individual';
  	mailTemplateIndividualId(id: string): string { return `${this.mailTemplateIndividual}/${id}`; }
	smsTemplate = 'smstemplate';
	smsTemplateId(id: string): string { return `${this.smsTemplate}/${id}`; }

	/*updateColorSchemaDesign*/
	updateColorSchemaDesign(id: string): string { return `/current-user/update-color-schema-design/${id}`; }


	/* clients-settings */
	currentClient = 'client';
	baseClientList = 'client/all';
	editClient(id: string): string {return `client/${id}`;}
	clientToArchive(id: string): string {return `client/to-archive/${id}`;}
	clientExtractArchive(id: string): string {return `client/extract-archive/${id}`;}


	/* user-client-settings */
	currentUserclient = 'user-client';
	userClientList = `${this.currentUserclient}/all`;
	userEdit(id: string): string {return `${this.currentUserclient}/${id}`;}
	userClientToArchive(id: string): string {return `${this.currentUserclient}/to-archive/${id}`;}
	userClientExtractArchive(id: string): string {return `${this.currentUserclient}/extract-archive/${id}`;}

	/* partners-settings */
	currentPartner = 'agent';
	partnerList = 'agent/all';
	editPartner(id: string): string {return `agent/${id}`;}
	partnerToArchive(id: string): string {return `agent/to-archive/${id}`;}
	partnerExtractArchive(id: string): string {return `agent/extract-archive/${id}`;}

	/* user-agent */
	currentUserPartner = 'user-agent';
	userPartnerList = `${this.currentUserPartner}/all`;
	userPartnerEdit(id: string): string {return `${this.currentUserPartner}/${id}`;}
	userPartnerToArchive(id: string): string {return `${this.currentUserPartner}/to-archive/${id}`;}
	userPartnerExtractArchive(id: string): string {return `${this.currentUserPartner}/extract-archive/${id}`;}


	storageRequest = 'application/';
	storageRequestsStatusCount = 'storage-request/status-count-all';
	storageRequestIdNew(id: string): string { return `${this.storageRequest}find/${id}`; }
	applicationId(id: string): string { return `${this.storageRequest}${id}`; }
	storageRequestDocs(id: string): string { return `${this.applicationId(id)}/all-document`; }
	storageRequestDocsReset(id: string): string { return `${this.applicationId(id)}/reset`; }
	storageRequestUploadDocument(appId: string): string { return `${this.applicationId(appId)}/add-document`; }
	commentStorageRequest(appId: string): string { return `${this.applicationId(appId)}/comment`; }
	contractStorageRequest(appId: string): string { return `${this.applicationId(appId)}/contract-number`; }
	storageRequestFieldDocumentTypes(id: string): string { return `request-document-types/${id}`; }
	storageRequestDocumentRequirement(docId: string): string { return `${this.storageRequest}${docId}/verify`; }
	applicationDownload = 'application/download';
	applicationFileDelete(docId: string) { return `${this.storageRequest}${docId}/delete`; };
	downloadFiledocument(docId: string) { return 'file/' + docId; }
	storageRequestBinary(uuids: string): string { return 'storage-request/' + uuids + '/sign'; }
	storageValidator(uuids: string): string { return 'storage-request/' + uuids + '/validator'; }
	downloadStorageFileId(fileId: string): string { return `application/${fileId}/temporary-document/preview`; }
	storageRequestTemporaryDocumentUpload(fileId: string): string { return `application/${fileId}/temporary-document/upload`; }
	agentCandidates(appId: string): string {return `${this.applicationId(appId)}/agent-candidates`};

	/* electronicDocuments */

	electronicGenerate(requestId: string): string { return `electronic-document/${requestId}/generate`; }
	electronicGenerateMetaData(requestId: string): string { return `electronic-document/${requestId}/generate-metadata`; }
	electronicSave(requestId: string): string { return `electronic-document/${requestId}/save-metadata`; }

	/* application */
	applicationNextStatus(appId: string): string {return `application/${appId}/next-status`};
	eventsList = 'events';
	individualRequestsAll = 'application/all';
	storageRequestIndividualFind(id: string): string {return `application/find/${id}`;}
	applicationEdit(id: string): string { return `application/${id}`; }
	individualstorageRequestBankForm(id: string): string { return `individual/storage-request/${id}/generatebankform`; }
	applicationStatus = 'application/status'
	applicationSendOfferClient = 'application/send-offer-client'
	applicationAction = `${this.storageRequest}action`


	/* questionnaire */

	questionnaire(id: string): string { return `${this.applicationId(id)}/questionnaire-new/`;}

	/* camunda */

	businessProcess = 'business-process/get-process'
	businessProcessList = 'business-process/list'
	businessProcessDownload = 'business-process/download'
	businessProcessDelete = 'business-process/delete'

	logo_img: string = this.baseURL + 'logo/login';
	logo_header: string = this.baseURL + 'logo/system';
	bg_img: string = this.baseURL + 'system/image/BG_MAIN_IMAGE';
	bg_content: string = this.baseURL + 'system/image/BG_CONTENT_IMAGE';
}

export const uri = new Uri();
